export const ArrowTopRightIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7058 2.6001H4.54269C4.15869 2.6001 3.84642 2.9123 3.84642 3.29623C3.84642 3.68015 4.15869 3.99235 4.54269 3.99235H11.0222L2.80414 12.2109C2.53196 12.483 2.53196 12.9239 2.80414 13.196C3.07631 13.4681 3.51728 13.4681 3.78946 13.196L12.0075 4.97748V11.4557C12.0075 11.8396 12.3197 12.1518 12.7037 12.1518C13.0877 12.1518 13.4 11.8396 13.4 11.4557V3.29623C13.4021 2.9123 13.0898 2.6001 12.7058 2.6001Z"
        fill="#05796B"
      />
    </svg>
  );
};
